import { defineComponent as _defineComponent } from 'vue';
import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex items-center w-full"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "grow"
}, null, -1);
import RichDialog from "@/modules/vue/components/RichDialog.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'QueryFilterForm',
  props: {
    defaultForm: null
  },
  emits: ['update:form', 'changed'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const form = ref(Object.assign({}, props.defaultForm));
    const onApply = () => {
      emit('update:form', form.value);
      emit('changed');
      hide();
    };
    const onReset = () => {
      form.value = Object.assign({}, props.defaultForm);
    };
    const dialog = ref(null);
    const show = () => dialog.value.show();
    const hide = () => dialog.value.hide();
    expose({
      show,
      hide
    });
    return (_ctx, _cache) => {
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createBlock(RichDialog, {
        ref_key: "dialog",
        ref: dialog
      }, {
        action: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_NButton, {
          secondary: "",
          onClick: onReset
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('reset')), 1)]),
          _: 1
        }), _hoisted_2, _createVNode(_component_NButton, {
          secondary: "",
          type: "success",
          onClick: onApply
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('apply')), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
          form: form.value
        })))]),
        _: 3
      }, 512);
    };
  }
});